"use client"
import { Radio, RadioGroup, Stack } from "@chakra-ui/react"
import axios from "axios"
import { useEffect, useRef, useState } from "react"
import DatePicker from "react-datepicker"
import { NotificationManager } from "react-notifications"
import { useParams } from "react-router-dom"
import Select from "react-select"
import dollor from "../../../assets/icons/dollar.svg"
import percentage from "../../../assets/icons/percentage.svg"
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown"
import InputWithIcon from "../../../components/InputWithIcon"
import useAuth from "../../../hooks/useAuth"
import { BASE_URL } from "../../../utils/Element"

const AddOfferData = ({
  showModal,
  formData,
  disable,
  error,
  onSetFormData,
  onSetError,
  handleSubmit,
  handleClose,
  from,
}) => {
  const [config] = useAuth()
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [sellerOptions, setSellerOptions] = useState([])
  const selectRef = useRef(null)
  const [buyerOptions, setBuyerOptions] = useState([])
  const [bdsOptions, setBdsOptions] = useState([])
  const [bdsSellerOptions, setBdsSellerOptions] = useState([])
  const [offerVisionOptions, setOfferVisionOptions] = useState([])
  const [brBuyerOptions, setBrBuyerOptions] = useState([])
  const [brSellerOptions, setBrSellerOptions] = useState([])

  // Store property data separately to work around SearchDropdown limitations
  const [propertyDataMap, setPropertyDataMap] = useState({})

  const [propertyOptions, setPropertyOptions] = useState([])
  const [onbuyerOptions, onSetBuyerOptions] = useState([])
  const [onsellerOptions, onSetSellerOptions] = useState([])
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [showBrokerFields, setShowBrokerFields] = useState(false)
  const [showBdsFields, setShowBdsFields] = useState(false)

  const fetchPropertySuggestions = (inputValue = "") => {
    // check if portfolio is selected
    const isPortfolio = formData?.portfolio === 1

    axios
      .get(
        `${BASE_URL}/get-datalisting?list=despositions&search=${inputValue}&portfolio=${isPortfolio ? 1 : 0}`,
        config,
      )
      .then((res) => {
        const leads = res.data?.data?.leads || []
        const dataMap = {}

        const options = leads.map((el) => {
          dataMap[el.id] = el
          return {
            value: el.id,
            label: el.property_name,
            desc: `${el.street_address || ""}, ${el.city || ""}, ${el.state || ""}`,
            offer_id: el.id,
          }
        })

        setPropertyOptions(options)
        setPropertyDataMap(dataMap)
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message)
        }
      })
  }

  const fetchBuyer = (inputValue) => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=acquisition&search=${inputValue}`, config)
      .then((res) => {
        const leads = res.data?.data?.leads || []
        const options = leads.map((el) => ({
          label: `${el?.contact_name_full}`,
          value: el?.id,
          contact_id: el?.contact_id,
          contact_name: el?.contact_name_full,
        }))
        onSetBuyerOptions(options)
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message)
        }
      })
  }

  const fetchSeller = (inputValue, companyId = null) => {
    let apiUrl = `${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}`
    if (companyId) {
      apiUrl += `&company_id=${companyId}`
    }
    axios
      .get(apiUrl, config)
      .then((res) => {
        const sellers = res.data?.data?.contact_list || []
        const options = sellers.map((el) => ({
          label: `${el?.first_name} ${el?.last_name} `.trim(),
          value: el?.id,
        }))
        onSetSellerOptions(options)
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message)
        }
      })
  }

  useEffect(() => {
    if (isSidebarOpen) {
      fetchPropertySuggestions()
      fetchBuyer()
      fetchSeller()
    }
  }, [isSidebarOpen, formData?.portfolio])

  const handleChange = (value, key) => {
    onSetFormData({ ...formData, [key]: value })
  }

  const clearPropertyRelatedFields = () => {
    const updatedFormData = {
      ...formData,
      offer_id: "",
      property: null,
      company: "",
      seller: "",
      owner_company_id: "",
      owner_contact_id: "",
      owner_type: "",
    }
    onSetFormData(updatedFormData)
  }

  const fetchSuggestions = (inputValue, type, brokerType) => {
    let apiListKey = ""
    if (type === "broker_seller") {
      apiListKey = `broker_${brokerType}_seller`
    } else if (type === "broker_buyer") {
      apiListKey = `broker_${brokerType}_buyer`
    } else {
      // For BDS, the brokerType is already the correct list name (e.g., "BDS_Seller", "BDS_Buyer")
      apiListKey = brokerType
    }


    axios
      .get(`${BASE_URL}/get-datalisting?list=${apiListKey}&search=${inputValue}`, config)
      .then((res) => {
        const data = Array.isArray(res?.data?.data) ? res.data.data : []

        let options = []

        if (type === "broker_seller") {
          if (data.length > 0) {
            options = data.map((el) => ({
              value: el?.id,
              label: `${el?.first_name || ""} ${el?.last_name || ""}`.trim(),
            }))
          }
          setBrSellerOptions(options)
        } else if (type === "broker_buyer") {
          if (data.length > 0) {
            options = data.map((el) => ({
              value: el?.id,
              label: `${el?.first_name || ""} ${el?.last_name || ""}`.trim(),
            }))
          }
          setBrBuyerOptions(options)
        } else if (type === "bds_seller") {
          if (data.length > 0) {
            options = data.map((el) => ({
              value: el?.id,
              label: `${el?.first_name || ""} ${el?.last_name || ""}`.trim(),
            }))
          }
          setBdsSellerOptions(options)
        } else if (type === "bds_buyer") {
          if (data.length > 0) {
            options = data.map((el) => ({
              value: el?.id,
              label: `${el?.first_name || ""} ${el?.last_name || ""}`.trim(),
            }))
          }
          setBdsOptions(options)
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message)
        }
      })
  }

  const fetchOfferVision = () => {
    setLoading(true)
    axios
      .get(`${BASE_URL}/offer-version-data`, config)
      .then((res) => {
        const data = res?.data?.data
        if (!data || typeof data !== "object") {
          setOfferVisionOptions([])
          return
        }
        const options = Object.entries(data).map(([key, value]) => ({
          value: key,
          label: value,
        }))
        setOfferVisionOptions(options)
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message)
        }
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (showModal) {
      fetchOfferVision()
    }
  }, [showModal])

  useEffect(() => {
    if (!showModal) {
      setPropertyDataMap({})
    }
  }, [showModal])

  const handlePortfolioChange = (value) => {
    const portfolioStatus = formData.portfolio ? 0 : 1
    onSetFormData({ ...formData, portfolio: portfolioStatus, link: "" })
  }

  const handleRemoveBrokerFields = () => {
    setShowBrokerFields(false)
    onSetFormData({
      ...formData,
      br_seller_id: "",
      br_buyer_id: "",
      broker_seller: "",
      broker_buyer: "",
      broker_seller_type: "",
      seller_exclusive_id: "",
      seller_lead_id: "",
      broker_buyer_type: "",
      buyer_exclusive_id: "",
      buyer_lead_id: "",
    })
  }

  const handleRemoveBdsFields = () => {
    setShowBdsFields(false)
    onSetFormData({
      ...formData,
      bds_seller_id: "",
      bds_buyer_id: "",
      bds_seller: "",
      bds_buyer: "",
    })
  }

  // Formula calculations
  const calculateOfferPrice = (noi, capRate) => {
    if (!noi || !capRate || capRate === "0") return "";
    const capDecimal = parseInt(capRate) / 100;
    if (capDecimal === 0) return "";
    const price = Math.round(parseFloat(noi) / capDecimal);
    return price.toString();
  };

  const calculateOfferCapRate = (noi, price) => {
    if (!noi || !price || price === "0") return "";
    const capRate = ((parseFloat(noi) / parseFloat(price)) * 100).toFixed(2);
    return capRate;
  }

  const updateFormWithFormula = (newFormData) => {
    onSetFormData({ ...formData, ...newFormData });
  };

  const handleNoiChange = (e) => {
    const noiValue = e.target.value;
    let updates = { noi_rent: noiValue };

    if (formData.offer_cap_rate && noiValue !== "") {
      // Update price from NOI and cap rate
      updates.offer_price = calculateOfferPrice(noiValue, formData.offer_cap_rate);
    } else if (formData.offer_price && noiValue !== "") {
      // Update cap rate from NOI and price
      updates.offer_cap_rate = calculateOfferCapRate(noiValue, formData.offer_price);
    }

    updateFormWithFormula(updates);
  };

  const handleOfferCapRateChange = (e) => {
  const capRateValue = e.target.value;
  const regex = /^\d*\.?\d*$/;
  const numValue = parseFloat(capRateValue);
  if (capRateValue === "" || (regex.test(capRateValue) && !isNaN(numValue))) {
    let updates = { offer_cap_rate: capRateValue };

    if (formData.noi_rent && capRateValue !== "" && numValue > 0 && numValue <= 100) {
      // Update price from NOI and cap rate only if cap rate is valid range
      updates.offer_price = calculateOfferPrice(formData.noi_rent, capRateValue);
    }

    updateFormWithFormula(updates);
  }
};

  const handleOfferPriceChange = (e) => {
    const priceValue = e.target.value;
    const regex = /^\d*$/;
    if (priceValue === "" || regex.test(priceValue)) {
      let updates = { offer_price: priceValue };

      if (formData.noi_rent && priceValue !== "") {
        // Update cap rate from NOI and price
        updates.offer_cap_rate = calculateOfferCapRate(formData.noi_rent, priceValue);
      }

      updateFormWithFormula(updates);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex gap-4">
        <div className="mt-5 w-[48%]">
          <label className="dark-H head-4 mb-2">Offer Date</label>
          <DatePicker
            className="body-N"
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            selected={formData.created_at ? new Date(formData.created_at) : null}
            onChange={(value) => {
              onSetError({ ...error, created_at: "" })
              handleChange(value, "created_at")
            }}
          />
          {error?.created_at && <p className="body-S red-D">{error?.created_at}</p>}
        </div>
        <div className="mt-5 w-[48%]">
          <label className="dark-H head-4 mb-2 required:*:">Offer Version</label>
          <div className="mt-1.5">
            <Select
              ref={selectRef}
              className="body-N"
              options={offerVisionOptions}
              placeholder={"Offer Version"}
              value={offerVisionOptions?.find((option) => option?.value === formData.offer_version)}
              onChange={(option) => {
                onSetError("offer_version")
                handleChange(option?.value, "offer_version")
              }}
            />
          </div>
          {error?.offer_version && <span className="body-S red-D">{error?.offer_version}</span>}
        </div>
      </div>

      <div className="mt-6">
        <label className="container" style={{ marginBottom: "0px" }}>
          <p style={{ paddingLeft: "30px" }} className="dark-H head-4">
            Portfolio
          </p>
          <input
            type="checkbox"
            checked={formData?.portfolio}
            className="body-N"
            onChange={(value) => {
              handlePortfolioChange(value)
            }}
          />
          <span className="checkmark"></span>
        </label>
      </div>

      <div className="mt-5">
        <label className="dark-H head-4 mb-2">Property Name</label>
        <SearchDropdown
          placeholder="Search Property Here"
          text={formData?.property?.name}
          options={propertyOptions}
          fetchSuggestions={fetchPropertySuggestions}
          onSetOptions={(value) => setPropertyOptions(value)}
          handleSelect={(option) => {
            const propertyData = propertyDataMap[option?.value]
            const isCompanyOwner = propertyData?.owner_info_type === "company"
            const isContactOwner = propertyData?.owner_info_type === "contact"

            const updatedFormData = {
              ...formData,
              offer_id: option?.value,
              property: {
                id: option?.value,
                name: option?.label,
              },
              owner_type: propertyData?.owner_info_type || "",
              asking_price: propertyData?.asking_price || "",
              asking_cap_rate: propertyData?.asking_cap_rate || "",
              noi_rent: propertyData?.anual_rent || "",
            }

            if (isCompanyOwner) {
              updatedFormData.company = propertyData?.owner?.name || propertyData?.owner_name || ""
              updatedFormData.owner_company_id = propertyData?.owner_company_id || propertyData?.owner?.id || ""
              updatedFormData.seller = ""
              updatedFormData.owner_contact_id = ""
            } else if (isContactOwner) {
              const contactName =
                propertyData?.owner?.name ||
                propertyData?.owner_name ||
                `${propertyData?.owner?.first_name || ""} ${propertyData?.owner?.last_name || ""}`.trim() ||
                ""
              updatedFormData.seller = {
                id: propertyData?.owner_contact_id || propertyData?.owner?.id || "",
                name: contactName,
              }
              updatedFormData.owner_contact_id = propertyData?.owner_contact_id || propertyData?.owner?.id || ""
              updatedFormData.company = ""
              updatedFormData.owner_company_id = ""
            } else {
              updatedFormData.company = ""
              updatedFormData.seller = ""
              updatedFormData.owner_company_id = ""
              updatedFormData.owner_contact_id = ""
            }

            onSetFormData(updatedFormData)
            setPropertyOptions([])
          }}
          onClear={clearPropertyRelatedFields}
          onInputChange={(value) => {
            if (!value || value.trim() === "") {
              clearPropertyRelatedFields()
            }
          }}
        />

        {error?.property_name && <p className="body-S red-D pt-1">{error?.property_name}</p>}
      </div>
      {formData?.owner_type === "company" && formData?.company && (
        <div className="mt-5">
          <label className="dark-H head-4 mb-2">Company</label>
          <input
            className="body-N"
            name="company"
            type="text"
            placeholder="Company Name"
            value={formData.company || ""}
            onChange={(e) => {
              onSetError({ ...error, company: "" })
              handleChange(e.target.value, "company")
            }}
          />
          {error?.company && <span className="body-S red-D">{error?.company}</span>}
        </div>
      )}
      <div className="flex gap-4 mt-5">
        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2">Seller</label>
          <Select
            className="body-N"
            placeholder="Write Seller Here"
            value={formData?.seller ? { value: formData.seller.id, label: formData.seller.name } : null}
            onChange={(option) => {
              onSetFormData({
                ...formData,
                seller_id: option?.value,
                seller: {
                  id: option?.value,
                  name: option?.label,
                },
              })
              onSetSellerOptions([])
            }}
            onMenuOpen={() => {
              const companyId = formData?.owner_company_id || null
              fetchSeller("", companyId)
            }}
            onInputChange={(inputValue) => {
              // Filtering handled by react-select internally
            }}
            options={onsellerOptions}
            isSearchable={true}
            filterOption={(option, inputValue) => {
              return option.label.toLowerCase().includes(inputValue.toLowerCase())
            }}
          />
          {error?.seller && <span className="body-S red-D">{error?.seller}</span>}
        </div>
        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2">Buyer</label>
          <SearchDropdown
            placeholder="Search Buyer Here"
            text={formData?.buyer?.name}
            options={onbuyerOptions}
            fetchSuggestions={fetchBuyer}
            onSetOptions={(value) => onSetBuyerOptions(value)}
            handleSelect={(option) => {
              onSetFormData({
                ...formData,
                buyer_id: option?.value,
                buyer: {
                  id: option?.value,
                  name: option?.label,
                  contact_id: option?.contact_id,
                  contact_name: option?.contact_name,
                },
              })
              onSetBuyerOptions([])
            }}
          />
          {error?.buyer && <span className="body-S red-D">{error?.buyer}</span>}
        </div>
      </div>

      <div className="mt-5">
        <label className="dark-H head-4 mb-2">NOI</label>
        <InputWithIcon
          icon={dollor}
          type="number"
          placeholder="NOI"
          value={formData?.noi_rent || ""}
          onChange={handleNoiChange}
          onWheel={(e) => e.target.blur()}
        />
        {error?.noi_rent && <span className="body-S red-D">{error?.noi_rent}</span>}
      </div>


      <div className="flex gap-4 mt-5">
        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2 required:*:">Asking Cap Rate</label>
          <InputWithIcon
            icon={percentage}
            className="body-N"
            name="contact"
            type="number"
            placeholder="Write Here"
            value={formData?.asking_cap_rate || ""}
            onChange={(e) => {
              handleChange(e.target.value, "asking_cap_rate")
            }}
            onWheel={(e) => e.target.blur()}
          />
          {error?.asking_cap_rate && <span className="body-S red-D">{error?.asking_cap_rate}</span>}
        </div>
        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2 required:*:">Asking Price</label>
          <InputWithIcon
            icon={dollor}
            className="body-N"
            name="contact"
            type="number"
            placeholder="Write Here"
            value={formData?.asking_price || ""}
            onChange={(e) => {
              handleChange(e.target.value, "asking_price")
            }}
            onWheel={(e) => e.target.blur()}
          />
          {error?.asking_price && <span className="body-S red-D">{error?.asking_price}</span>}
        </div>
      </div>

      <div className="flex gap-4 mt-5">
        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2 ">
            Offer Cap Rate
          </label>
          <InputWithIcon
            icon={percentage}
            type="number"
            placeholder="Offer Cap Rate"
            value={formData?.offer_cap_rate || ""}
            onChange={handleOfferCapRateChange}
            onWheel={(e) => e.target.blur()}
          />
          {error?.offer_cap_rate && <span className="body-S red-D">{error?.offer_cap_rate}</span>}
        </div>
        <div className="w-[50%]">
          <label className="dark-H head-4 mb-2">
            Offer Price
          </label>
          <InputWithIcon
            icon={dollor}
            type="number"
            placeholder="Offer Price"
            value={formData?.offer_price || ""}
            onChange={handleOfferPriceChange}
            onWheel={(e) => e.target.blur()}
          />
          {error?.offer_price && <span className="body-S red-D">{error?.offer_price}</span>}
        </div>
      </div>
      <div className="mt-5">
        <button
          type="button"
          className="light-L head-5 green-bg-H save-button"
          onClick={() => setShowBrokerFields(!showBrokerFields)}
        >
          Add Broker
        </button>
        {showBrokerFields && (
          <div className="mt-4 border p-4 rounded relative">
            <button
              type="button"
              className="absolute top-2 right-2 text-sm text-red-600 underline"
              onClick={handleRemoveBrokerFields}
            >
              Remove
            </button>

            <div className="flex gap-4">
              <div className="w-[48%]">
                <label className="dark-H head-4 mb-2 required:*:">Broker Representing Seller</label>
                <div className="mt-2 mb-3">
                  <RadioGroup
                    onChange={(value) => {
                      onSetFormData({
                        ...formData,
                        broker_seller_type: value,
                        br_seller_id: [],
                        broker_seller: [],
                      })
                      setBrSellerOptions([])
                    }}
                    value={formData.broker_seller_type || ""}
                  >
                    <Stack direction="row" gap={3}>
                      <Radio value="inside">Inside</Radio>
                      <Radio value="outside">Outside</Radio>
                    </Stack>
                  </RadioGroup>
                  {error?.broker_seller_type && <span className="body-S red-D">{error?.broker_seller_type}</span>}
                </div>
                {formData.broker_seller_type && (
                  <div className="mt-3">
                    <Select
                      isMulti
                      className="body-N"
                      placeholder="Search and select brokers"
                      options={brSellerOptions}
                      value={
                        Array.isArray(formData.broker_seller)
                          ? formData.broker_seller.map((broker) => ({
                            value: broker.id || broker.value,
                            label: broker.name || broker.label,
                          }))
                          : []
                      }
                      onChange={(selectedOptions) => {
                        const selectedBrokers = selectedOptions.map((option) => ({
                          id: option.value,
                          name: option.label,
                        }))
                        const selectedIds = selectedOptions.map((option) => option.value)

                        onSetFormData({
                          ...formData,
                          br_seller_id: selectedIds,
                          broker_seller: selectedBrokers,
                          ...(formData.broker_seller_type === "inside"
                            ? { seller_exclusive_id: selectedIds }
                            : { seller_lead_id: selectedIds }),
                        })
                      }}
                      onInputChange={(inputValue) => {
                        if (inputValue) {
                          fetchSuggestions(inputValue, "broker_seller", formData.broker_seller_type)
                        }
                      }}
                      onMenuOpen={() => {
                        if (formData.broker_seller_type && brSellerOptions.length === 0) {
                          fetchSuggestions("", "broker_seller", formData.broker_seller_type)
                        }
                      }}
                      isSearchable={true}
                      isClearable={true}
                    />
                    {error?.broker_seller && <span className="body-S red-D">{error?.broker_seller}</span>}
                  </div>
                )}
              </div>
              <div className="w-[48%]">
                <label className="dark-H head-4 mb-2 required:*:">Broker Representing Buyer</label>
                <div className="mt-2 mb-3">
                  <RadioGroup
                    onChange={(value) => {
                      onSetFormData({
                        ...formData,
                        broker_buyer_type: value,
                        br_buyer_id: [],
                        broker_buyer: [],
                      })
                      setBrBuyerOptions([])
                    }}
                    value={formData.broker_buyer_type || ""}
                  >
                    <Stack direction="row" gap={3}>
                      <Radio value="inside">Inside</Radio>
                      <Radio value="outside">Outside</Radio>
                    </Stack>
                  </RadioGroup>
                  {error?.broker_buyer_type && <span className="body-S red-D">{error?.broker_buyer_type}</span>}
                </div>
                {formData.broker_buyer_type && (
                  <div className="mt-3">
                    <Select
                      isMulti
                      className="body-N"
                      placeholder="Search and select brokers"
                      options={brBuyerOptions}
                      value={
                        Array.isArray(formData.broker_buyer)
                          ? formData.broker_buyer.map((broker) => ({
                            value: broker.id || broker.value,
                            label: broker.name || broker.label,
                          }))
                          : []
                      }
                      onChange={(selectedOptions) => {
                        const selectedBrokers = selectedOptions.map((option) => ({
                          id: option.value,
                          name: option.label,
                        }))
                        const selectedIds = selectedOptions.map((option) => option.value)

                        onSetFormData({
                          ...formData,
                          br_buyer_id: selectedIds,
                          broker_buyer: selectedBrokers,
                          ...(formData.broker_buyer_type === "inside"
                            ? { buyer_exclusive_id: selectedIds }
                            : { buyer_lead_id: selectedIds }),
                        })
                      }}
                      onInputChange={(inputValue) => {
                        if (inputValue) {
                          fetchSuggestions(inputValue, "broker_buyer", formData.broker_buyer_type)
                        }
                      }}
                      onMenuOpen={() => {
                        if (formData.broker_buyer_type && brBuyerOptions.length === 0) {
                          fetchSuggestions("", "broker_buyer", formData.broker_buyer_type)
                        }
                      }}
                      isSearchable={true}
                      isClearable={true}
                    />
                    {error?.broker_buyer && <span className="body-S red-D">{error?.broker_buyer}</span>}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="mt-5">
        <button
          type="button"
          className="light-L head-5 green-bg-H save-button"
          onClick={() => setShowBdsFields(!showBdsFields)}
        >
          Add BDS
        </button>
        {showBdsFields && (
          <div className="flex gap-4 mt-4 border p-4 rounded relative">
            <button
              type="button"
              className="absolute top-2 right-2 text-sm text-red-600 underline"
              onClick={handleRemoveBdsFields}
            >
              Remove
            </button>
            <div className="w-[48%]">
              <label className="dark-H head-4 mb-2 required:*:">BDS (Seller)</label>
              <SearchDropdown
                isTop={false}
                placeholder={`BDS Seller`}
                text={formData?.bds_seller}
                options={bdsSellerOptions}
                fetchSuggestions={(inputValue) => fetchSuggestions(inputValue, "bds_seller", "BDS_Seller")}
                onSetOptions={(value) => setBdsSellerOptions(value)}
                handleSelect={(option) => {
                  onSetFormData({ ...formData, bds_seller_id: option?.value, bds_seller: option?.label })
                  setBdsSellerOptions([])
                }}
              />
              {error?.bds_seller && <span className="body-S red-D">{error?.bds_seller}</span>}
            </div>
            <div className="w-[48%]">
              <label className="dark-H head-4 mb-2 required:*:">BDS (Buyer)</label>
              <SearchDropdown
                isTop={false}
                placeholder={`BDS Buyer`}
                text={formData?.bds_buyer}
                options={bdsOptions}
                fetchSuggestions={(inputValue) => fetchSuggestions(inputValue, "bds_buyer", "BDS_Buyer")}
                onSetOptions={(value) => setBdsOptions(value)}
                handleSelect={(option) => {
                  onSetFormData({ ...formData, bds_buyer_id: option?.value, bds_buyer: option?.label })
                  setBdsOptions([])
                }}
              />
              {error?.bds_buyer && <span className="body-S red-D">{error?.bds_buyer}</span>}
            </div>
          </div>
        )}
      </div>
      <div className="mt-6">
        <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
          Save
        </button>
        <button type="button" onClick={handleClose} className="green-H ml-5">
          Cancel
        </button>
      </div>
    </form>
  )
}

export default AddOfferData